import { render, staticRenderFns } from "./SfProductCardHorizontal.vue?vue&type=template&id=14f06814"
import script from "./SfProductCardHorizontal.vue?vue&type=script&lang=js"
export * from "./SfProductCardHorizontal.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./SfProductCardHorizontal.vue?vue&type=style&index=0&id=14f06814&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "0470eff0"
  
)

export default component.exports